export const configData = {
  supAss:"SupAss", //状态
  calculationType:"CalculationType",  //实际结果计算类型
  determineType:"Determine Type",//最终分值确定类型
  optionType:"Option type",     //选项类型
  periodType:"PeriodType", //期间类型
  businessScope:"BusinessScope", //供应商及其业务范围
  taskTimedState:"supAssTaskTimedState", //定时任务状态
  approvalStatus:"approvalStatus",  //审批状态
  taskType:"taskType"  //任务类型
};
